// extracted by mini-css-extract-plugin
export default {"searchSubtitle":"pYKYwG","subtitleNewBrandingStyles":"Ifl_mB"};